import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { setContractMode } from '../../store/reducers/contractsSlice';
import { setRequestMode } from '../../store/reducers/requestsSlice';
import './Dashboard.css'
import contrato from '../../imgs/contrato.png';
import solicitud from '../../imgs/solicitud.png';

const Dashboard = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleAddNewRequest = async () => {
        dispatch(setRequestMode('new'));
        navigate('/request');
    }

    const handleAddNewContract = async () => {
        dispatch(setContractMode('new'));
        navigate('/contract');
    }

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-20">
            <div className="w-[85%] min-w-[900px] bg-white h-[90%] my-auto rounded-2xl">
                <h2 className="2xl:py-8 2xl:leading-[75px] text-[30px] 2xl:text-[40px] mt-7 titleRequests">Inicio</h2>
                <div className="2xl:w-[65%] w-[80%] mx-auto flex flex-row items-center justify-center gap-16 2xl-gap-52 mt-32">
                    <div className="relative itemDashboard w-[400px] min-w-[400px] h-[300px] min-h-[300px] ">
                        <img className="absolute top-7 left-36" src={contrato} alt="nuevoContrato" />
                        <button onClick={handleAddNewContract} className="itemButton">Crear contrato</button>
                    </div>
                    <div className="relative itemDashboard w-[400px] min-w-[400px] h-[300px] min-h-[300px] ">
                        <img className="absolute top-7 left-36" src={solicitud} alt="nuevaSolicitud" />
                        <button onClick={handleAddNewRequest} className="itemButton">Crear solicitud</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;